// extracted by mini-css-extract-plugin
export default {"container":"turnscreen_container__9Dpys","img":"turnscreen_img__wJ290"};